/* import __COLOCATED_TEMPLATE__ from './group-manage-logs-row.hbs'; */
import Component from "@ember/component";
import { action } from "@ember/object";

export default Component.extend({
  tagName: "",
  expandDetails: false,

  @action
  toggleDetails() {
    this.toggleProperty("expandDetails");
  },

  @action
  filter(params) {
    this.set(`filters.${params.key}`, params.value);
  },
});
